/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ErrorModel } from '../models/ErrorModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TestService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Deletes the application cache entries.
     * @returns ErrorModel Error
     * @throws ApiError
     */
    public testCacheEntries(): CancelablePromise<ErrorModel> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/test/cache-entries',
        });
    }

    /**
     * Deletes a connection and associated data.
     * @param connectionId
     * @returns ErrorModel Error
     * @throws ApiError
     */
    public testDeleteConnection(
        connectionId: string,
    ): CancelablePromise<ErrorModel> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/rating/remove-connection',
            query: {
                'connectionId': connectionId,
            },
        });
    }

}
